import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import SortClientButton from '../atoms/SortClientButton';
import SortServerButton from '../atoms/SortServerButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openSort,
    updateOpenSort,
    cancelAction,
    sortClientAction,
    sortServerAction,
    searchSortKeyColumn,
    // sortTypeParamClient,
    // sortTypeParamServer,
    sortOrderParam
  }) => {
    return (
      <Dialog
        open={openSort}
        onClose={() => {
          updateOpenSort(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            全てのデータのソート順を変更しますか？（これには時間がかかります）
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <SortClientButton
            onClickAction={() => {
              sortClientAction(
                searchSortKeyColumn,
                // sortTypeParamClient,
                sortOrderParam
              );
              updateOpenSort(false);
            }}
          />
          <SortServerButton
            onClickAction={() => {
              sortServerAction(
                searchSortKeyColumn,
                // sortTypeParamServer,
                sortOrderParam
              );
              updateOpenSort(false);
            }}
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
